<template>
  <div class="ds--failure-retry" @click="fnClick">
    <div class="retry-icon" :style="iconStyle">
      <svg-icon :icon-class="svgIcon"></svg-icon>
    </div>
    <div class="retry-text" :style="textStyle">
      <span v-html="text"></span>
    </div>
  </div>
</template>
<script>
import Common from "@/utils/common";
export default {
  name: "DsFailureRetry",
  props: {
    //svg-icon 名称
    svgIcon: {
      type: String,
      default: "icon-failure-retry",
    },
    //icon大小（font-size，传入px值，自动转换为vw）
    iconSize: {
      type: Number,
      default: 100,
    },
    //描述文字
    text: {
      type: String,
      default: "獲取内容失敗，請點擊屏幕重試",
    },
    //描述文字大小（font-size，传入px值，自动转换为vw）
    textSize: {
      type: Number,
      default: 14,
    },
    //描述文字颜色
    textColor: {
      type: String,
      default: "#cfcfcf",
    },

    //@retry 事件：点击后触发
  },
  data() {
    return {
      iconStyle: {},
      textStyle: {},
    };
  },
  mounted() {
    let _iconStyle = {
      "font-size": `${Common.fnPxToViewPort(this.iconSize)}vw`,
    };
    this.iconStyle = _iconStyle;

    let _textStyle = {
      "font-size": `${Common.fnPxToViewPort(this.textSize)}vw`,
      color: this.textColor,
    };
    this.textStyle = _textStyle;
  },
  methods: {
    fnClick() {
      this.$emit("retry");
    },
  },
};
</script>
<style lang="scss" scoped>
.ds--failure-retry {
  height: calc(100vh - 30px);
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .retry-icon {
    // margin-top: -100px;
    font-size: 100px;
  }
  .retry-text {
    font-size: 14px;
    padding: 0px 25px;
    line-height: 21px;
    text-align: center;
  }
}
/* >= 801 視爲稍大點的平板或電腦屏幕（自定） */
@media (min-width: 501px) {
  .ds--failure-retry {
    height: calc(100vh - 30px);
    .retry-icon {
      font-size: 150px !important;
    }
    .retry-text {
      font-size: 18px !important;
      padding: 0px 25px;
      line-height: 21px;
    }
  }
}
</style>
